import Scrollbars from "react-custom-scrollbars-2";

const FormLayout = ({ title, children,isNoBack }) => {
  const renderTrack = ({ style, ...props }) => {
    const trackStyle = {
      display: "none",
    };
    return <div style={{ ...style, ...trackStyle }} {...props} />;
  };
  return (
    <>
      <div className="form-layout-header mt-4 align-items-center">
      {!isNoBack &&(
        <button className="pt-1 pb-1 w-120 Poppins_500" id="button" onClick={() => window.history.back()} style={{ height: "34px",display:"flex",justifyContent:"center" ,textAlign:"center",gap:"10px"}}> <span>←</span> <span>Back</span> </button>)}
        <h2 className="form-layout-title">{title}</h2>
      </div>
      <Scrollbars
        style={{ height: "calc(100vh - 95px)" }}
        renderView={(props) => <div {...props} className="view" />}
        renderTrackHorizontal={renderTrack}
        className="ScrollbarsSidebar"
      >
      <div className="form-layout-content white-box">{children}</div>
      </Scrollbars>
    </>
  );
};

export default FormLayout;
